<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
      <div class="container-post">
        <h1>Perindo Agenda</h1>
        <div class="search grid-input">
           <select class="select-css mg-right" v-model="sorting" @change="getListEvent('reset')">
              <option value="" selected>Select Sorting :</option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
          </select>
          <!-- <div class="search__heading">
              <img src="../assets/images/icon/iconmonstr-magnifier-4.svg" alt="">
              <div class="wrapper">
                  <div class="input-data search--input">
                      <input type="text" required>
                      <div class="underline"></div>
                      <label>Search</label>
                  </div>
              </div>
          </div> -->
          <!-- <div class="flexac">
              <select class="select-css mg-right" name="" id="" v-model="featured" @change="getListEvent">
                  <option value="" selected>Select Featured :</option>
                  <option value="true">Show</option>
                  <option value="false">Hide</option>
              </select>
              <select class="select-css" name="" id="" v-model="date" @change="getListEvent" v-if="!featured">
                  <option value="" selected>Select Date :</option>
                  <option value="now">Now</option>
                  <option value="past">Past</option>
                  <option value="future">Future</option>
              </select>
          </div> -->
          <div class="button-right">
              <!-- <button class="btn-add mg-right" @click="viewCat(1)">
                  View Category
              </button> -->
              <!-- <button class="btn-add mg-right" @click="viewRestore()">
                  View Restore
              </button> -->
              <button class="btn-add"  @click="viewForm()">
                  Add New
              </button>
          </div>
        </div>

        <div class="section-list">
          <ul class="main-post">
            <li class="list-post btm-margin">
              <p>Title</p>
              <p>Event Date</p>
              <p>Featured</p>
              <p>Last Update</p>
            </li>
            <div class="list-post__item">
              <li class="list-post" v-for="(data,index) in listAgenda" :key="index">
                <div class="list-post__title">
                  <p>{{ data.title }}</p>
                  <button class="button" @click="viewForm(data.event_id)">Edit</button>
                  <button class="button hov-del" @click="delEvent(data.event_id)">Delete</button>
                </div>
                <div>
                  <p>{{ data.event_start_date.split('T')[0] }} - {{ data.event_end_date.split('T')[0]}}</p>
                </div>
                <div>
                  <p class="main-post__author">{{ data.featured.Bool ? 'Show' : 'Hide' }}</p>
                </div>
                <div>
                  <p class="main-post__date">{{ formatDate(data.dtm_upd.Time) }}</p>
                  <button v-if="data.is_deleted.Bool == true" class="button" @click="resData(data.event_id)">Restore</button>
                </div>
              </li>
            </div>
          </ul>
          <paginate
            v-model="pageNum"
            :page-range="3"
            :page-count="totalPages"
            :margin-pages="2"
            :click-handler="getListEvent"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment';
import alert from './../commons/alert.helper';
import Loader from './../components/Loader.vue';

import auth from '@/service/auth.js'

export default {
    name: "PostAgenda",
    data() {
      return {
        isLoading: false,

        listAgenda: [],
        featured: "",
        date: "",
        pageNum: 1,
        totalPages: 0,
        limit: 10,
        sorting: '',
        // cache: false,  
      }
    },
    methods: {
      async getListEvent(page) {
        if (page === 'reset') {
          this.pageNum = 1
        } else {
          this.pageNum = page
        }
        this.isLoading = true
        try {
          const response = await axios.get('/content/listevent', {
            params: {
              // featured: this.featured,
              // timeline: this.date,
              page: this.pageNum,
              limit: this.limit,
              order: this.sorting,
              // cache: this.cache
            }
          })
          console.log(response)

          this.listAgenda = response.data.data
          console.log('agenda', this.listAgenda)
          // this.listAgenda = response.data.filter(item => {
          //   return item.is_deleted.Bool == false
          // })
          
          this.totalPages = Math.ceil(response.data.meta.total_data / this.limit)
          this.isLoading = false
            
        } catch (error) {
          console.log(error)
          this.isLoading = false
        }
      },
      async viewForm(id) {
        this.$router.push(`/agenda-Form/${id?id:0}`)
      },
      async delEvent(id) {
          let self = this
          alert.confirmation( async function () {
              self.isLoading = true
              try {
                  const response = await axios.delete(`/content/event/${id}`)
                  self.isLoading = false
                  console.log(response)
                  alert.success('Delete data success', () => self.getListEvent('reset'))
              } catch (error) {
                  self.isLoading = false
                  console.log(error)
                  alert.failed('Delete data failed')
              }
          }, 'Are you sure to delete it?')
      },
      async resData(id) {
        let self = this
        alert.confirmation( async function () {
        self.isLoading = true
            try {
                const response = await axios.patch(`/content/restoreevent/${id}`)
                self.isLoading = false
                console.log(response)
                alert.success('Restore data success', () => self.getListEvent('reset'))
            } catch (error) {
                self.isLoading = false
                console.log(error)
                alert.failed('Restore data failed')
            }
        }, 'Are you sure to restore this data?')
      },
      // viewCat(type) {
      //     this.$router.push(`/view-category/${type?type:0}`)
      // },
      // viewRestore() {
      //   this.$router.push(`/restore/event`)
      // },
      formatDate (val) {
        return moment(val).format('DD-MM-YYYY hh:mm:ss')
      }
    },
    async created () {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
        localStorage.clear()
        this.$router.push('/login')  
      }
      this.getListEvent('reset')
    },
    components: {
      Loader
    }
}
</script>